import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Button, Main, PageHeader } from '../../Components'
import axios from 'axios'
import { useConfirmationModal } from '../../Hooks/useNotifications'
import { useSelector } from 'react-redux'

import './billing.css'
import toast from 'react-hot-toast'
import { pricingPlans } from '../../Constants/Constants'
import { currencyFormatter } from '../../Helpers/Integer'
import moment from 'moment'
import {BsCheck2Square} from 'react-icons/bs'
export function StatuspageBillingDetails() {


	const { page_id } = useParams();
	const [searchParams , setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)
	const { getConfirmation } = useConfirmationModal();
	const { user , org } = useSelector((state) => state.auth)

	const [isLoading, setIsLoading] = useState({
		page : false ,
		purchasePlan : false ,
		
	})
	const [isLoadingStatuspageData, setIsLoadingStatuspageData] = useState(true)
	const [pageData, setPageData] = useState(null)
	const [displayPreviewUpcomingInvoice, setDisplayPreviewUpcomingInvoice] = useState(false) 
	const [changePricingPlanType, setChangePricingPlanType] = useState('Upgrade') 
	const [upcomingInvoiceData, setUpcomingInvoice] = useState(null ) 
	const [paymentResponse, setPaymentResponse] = useState('')

	



	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {

			setPaymentResponse(searchParams.get('return'));
			
			getStatuspageData();
			
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])


	/**
	 * 
	 * @returns 
	 */
	const getStatuspageData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingStatuspageData(true)
			// 
			// //
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setPageData(data)

					setIsLoadingStatuspageData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					if(error?.response?.data?.error ==='NOT_FOUND'){
						navigate('/pages')
					}
					setIsLoadingStatuspageData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingStatuspageData(false)
			}

		})
	} 

	/**
	 * 
	 * @returns 
	 */
	const subscribeToPlan = ({ selectedPlan = 'pro' , confirmUpdate = false , prorationData = false  }) => {

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading( (prevState) => ({
				...prevState,
				purchasePlan : true 
			}) )
			 
			
			if (user && user.token && org && org?.id ) {
				
				let params = { 
					statuspage_id :  pageData?.id,
					statuspage_name : pageData?.name,
					plan : selectedPlan,
					current_url : window.location.href,
					confirm_proration : confirmUpdate,
				}
				if(prorationData && prorationData > 0 ) params.subscription_proration_date = prorationData

				const token = user?.token;


				await axios.post(`${process.env.REACT_APP_API_URL}/stripe/create-checkout-session`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )

                    if(pageData?.plan ==='pro' && selectedPlan ==='business') setChangePricingPlanType('Upgrade') 
                    else if(pageData?.plan ==='business' && selectedPlan ==='pro') setChangePricingPlanType('Downgrade') 

					// toast.success('Your component has been successfully created') 
					
					if(data?.event === 'preview-upcoming-invoice'){
						// setDisplayPreviewUpcomingInvoice(true)
						// setUpcomingInvoice(data?.data)
						{/* CHANGE PRICING PLAN > PREVIEW UPCOMING INVOICE > CONFIRM */}
						const upcomingInvoiceData = data?.data; 
						getConfirmation({
							size : 'small',
							type: 'success',
							title: `${changePricingPlanType} Plan Confirmation`,
							message: <div className='modal__preview-upcoming-invoice'>
								<ul className='invoice-lines'>
									{
										upcomingInvoiceData?.lines?.data?.map( (line , index ) => {
											
											return (
												<li key={index}>
													<div className="description">{line?.description}</div>
													<div className="amount">{currencyFormatter(line?.amount/100)}</div>
												</li>
											)
										})
									}
								</ul>
								<div className="invoice-summary">
									<div className="invoice-sry-line subtotal"><label>Subtotal</label><span>{currencyFormatter(upcomingInvoiceData?.subtotal/100)}</span></div>
									<div className="invoice-sry-line subtotal"><label>Total</label><span>{currencyFormatter(upcomingInvoiceData?.total/100)}</span></div>
									{
                                        upcomingInvoiceData?.starting_balance !==0 && 
                                        <div className="invoice-sry-line subtotal">
                                            <label>Applied balance</label>
                                            <span>{currencyFormatter(upcomingInvoiceData?.starting_balance/100)}</span>
                                        </div>
                                    }
									<div className="invoice-sry-line total"><label>Amount due</label><span>{currencyFormatter(upcomingInvoiceData?.amount_due/100)}</span></div>
								</div>
							</div>,
							labels: { confirm: 'I confirm', cancel: "Cancel" },
							onConfirm : (response) => {
								subscribeToPlan({ selectedPlan , confirmUpdate : true , prorationData : upcomingInvoiceData?.subscription_proration_date })  
								 
							},
							onCancel : () => {
								 
				
							}
						});

					}else if(data?.success === true) {
						setPageData( prevState => ({
							...prevState,
							plan : data?.subscription?.plan_name
						}))
						setPaymentResponse('success')
					}else if(data?.url !==null && typeof data?.url !=='undefined') window.location.replace(data?.url)

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {



					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
					reject(__error)  
				})
			}else{
				setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * USE THE STRIPE CODE : stripe.subscriptions.update('sub_49ty4767H20z6a', {cancel_at_period_end: true});
	 */
	const downgradeToFreeConfirmation = () => {


		// Get the end of cycle for the selected subscription
		return new Promise( async (resolve, reject) => { 
			
			setIsLoading( (prevState) => ({
				...prevState,
				purchasePlan : true 
			}) )


			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}/subscription` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					//console.log(data)

					setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false 
					}) )

                    //console.log(moment.unix(data?.cycle_period_end).diff(moment() , 'days'));

					// Dipslay a popup to inform the user that we will cancel the current subscrpition a the end of the period 
					getConfirmation({
						size : 'small',
						type: 'success',
						title: `Downgrade to free plan`,
						message: <div>
							<p>You are about to downgrade to the free plan, please notice that you still have unused time left in your subscription until <b>{moment.unix(data?.cycle_period_end).format('LLLL')}</b>,</p>
							<p>After downgrading, your subscription will be automatically canceled at the end of your subscription period,</p>
							<p>You can still upgrade to paid plans at any time before canceling your subscription.</p>
						</div>,
						labels: { confirm: ( moment.unix(data?.cycle_period_end).diff(moment() , 'days') <= 0 ? 'I confirm' : 'Scheduled Downgrade') , cancel: "Cancel" },
						onConfirm : (response) => {
							// subscribeToPlan({ selectedPlan , confirmUpdate : true , prorationData : upcomingInvoiceData?.subscription_proration_date })  
							applyDowngradeFreePlan({statuspage_id : page_id})
						},
						onCancel : () => {
							

						}
					});

				})
				.catch(error => {



					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )

					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
					reject(__error)  
				})

			}else{

				setIsLoading( (prevState) => ({
					...prevState,
					purchasePlan : false 
				}) )

			}


			
			


		})
 
	}

	/**
	 * 
	 * @returns 
	 */
	const applyDowngradeFreePlan = async ({ statuspage_id }) => {

		return new Promise(async (resolve , reject) => {

			if (user && user.token && org && org?.id ) {
				
				let params = { 
					statuspage_id :  statuspage_id
				}

				const token = user?.token;


				await axios.post(`${process.env.REACT_APP_API_URL}/stripe/downgrade-free-plan`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {    

                    setPageData( prevState => ({
                        ...prevState,
                        plan : data?.current_page_plan,
                        subscription : {
                            ...prevState.subscription,
                            cancel_at : data?.cancel_at,
                            cancel_at_period_end : true ,
                        }

                    }))
                    // setPaymentResponse('success')
                    toast.success(`Your downgrade has been taken effect!`)
				})
				.catch(error => {



					let __error = "Something went wrong. thank you try later.";
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							__error = "Something went wrong. thank you try later.";
						}
					}

					toast.error(__error)  
					reject(__error)  
				})
			}else{
				setIsLoading( (prevState) => ({
						...prevState,
						purchasePlan : false
					}) )
				toast.error('Something went wrong, please try again later.') 
			}



		})

	}
 

	


	return (
		<>
		<Helmet>
			<title>{`Page billing - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: '/pages' },
				{ name: 'Page Billing', link: '' },
			]}
			 >
				{
					paymentResponse!==null && paymentResponse !=='' && 
					<div className={`alert alert-${paymentResponse ==='success' ? 'success' : 'danger'}`}>{
						paymentResponse === 'success' 
						? 'Your payment has been successfully processed'
						: 'Your payment has been canceled'
					}</div>
				}
				<PageHeader
					isLoading={isLoadingStatuspageData}
					title={`Page billing`}
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					 
					/>
				<div className="page-details">
					<div className="page-billing-details">
                        <div className="column">
                            <label htmlFor="">Plan Details </label>
                            <span>{`You're subscribed to ${pricingPlans?.find(x => x.value === pageData?.plan)?.label} plan.`}</span>
                        </div>
                        <div className="column">
                            {
                                pageData?.subscription?.cancel_at !==null && pageData?.subscription?.cancel_at > 0 &&   
                                <div className="cancel_date_alert">Your <b>{pricingPlans?.find(x => x.value === pageData?.plan)?.label}</b> subscription will canceled at <b>{moment.unix(pageData?.subscription?.cancel_at).format('LLLL')}</b></div>
                            }
                        </div>
					</div>
					<div className="billing-plans upgrade-plan">
						<div className="plans">
							<ul>
								{
									pricingPlans?.map( ( planItem , index) => 
										<li key={index} className={`plan-${planItem?.value}`}>
											<div className="plan-title">{planItem?.label}</div>
											<div className="plan-price">${planItem?.price}<span>/ month</span></div>
											{
												pageData?.plan === planItem?.value 
												? <Button className="plan-calltoaction" disabled>Current Plan</Button>
												: (
													planItem?.value ==='free'
													? (
                                                        pageData?.subscription?.cancel_at !==null && pageData?.subscription?.cancel_at > 0 
                                                        ? <Button color="red" className="plan-calltoaction auto-downgrade" disabled>Auto downgrade<span>On {moment.unix(pageData?.subscription?.cancel_at).format('LLLL')}</span></Button>
                                                        : <Button className="plan-calltoaction" onClick={ () => downgradeToFreeConfirmation()} loading={isLoading?.purchasePlan} >Select Plan</Button>
                                                    )
                                                    
													: <Button className="plan-calltoaction" onClick={() => subscribeToPlan({ selectedPlan : planItem?.value}) } loading={isLoading?.purchasePlan}>Select Plan</Button>

												)
											}                                                
											<div className="plan-desc">{planItem?.subtitle}</div>
											<div className="options">
												<ul>
													{
														planItem?.features?.map( (featureItem , featureIndex) => 
															<li key={featureIndex}><BsCheck2Square /> {featureItem}</li>
														)
													}
												</ul>
											</div>
										</li>
										)
								}
							</ul>
						</div>
					</div>
				</div>
				
		</Main>
		</>
	)
}
